export default {
    el: '#spark-app',

    /**
     * The application's data.
     */
    data() {
        return {
            user: Spark.state.user,
            // teams: Spark.state.teams,
            currentTeam: Spark.state.currentTeam,

            supportForm: new SparkForm({
                from: '',
                subject: '',
                message: '',
            }),
        }
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        let self = this

        Bus.$on('currentTeamUpdated', team => (this.currentTeam = team))

        Bus.$on('userUpdated', user => (this.user = user))
        //
        // Bus.$on('showNotifications', function () {
        //     $('#modal-notifications').modal('show');
        //
        //     self.markNotificationsAsRead();
        // });

        Bus.$on('showSupportForm', function(data) {
            Object.assign(self.supportForm, typeof data === 'undefined' ? {} : data)

            if (self.user) {
                self.supportForm.from = self.user.email
            }

            $('#modal-support').modal('show')

            setTimeout(() => {
                $('#support-subject').focus()
            }, 500)
        })
    },

    methods: {
        /**
         * Get the current team list.
         */
        getTeams() {
            axios.get('/' + Spark.pluralTeamString).then(response => (this.teams = response.data))
        },

        /**
         * Send a customer support request.
         */
        sendSupportRequest() {
            Spark.post('/support/email', this.supportForm).then(() => {
                $('#modal-support').modal('hide')

                this.showSupportRequestSuccessMessage()

                this.supportForm.subject = ''
                this.supportForm.message = ''
            })
        },

        /**
         * Show an alert informing the user their support request was sent.
         */
        showSupportRequestSuccessMessage() {
            swal({
                title: 'Sådan!',
                text: 'Vi har modtaget din besked og vender tilbage snarest!',
                type: 'success',
                showConfirmButton: false,
                timer: 2000,
            })
        },
    },
}
